export enum AppointmentsSegment {
  INSIGHTS = 'insights',
  PAST = 'past',
  UPCOMING = 'upcoming'
}
